import { createContext } from "react";

export const TempContext = createContext({});
